import { useMemo } from 'react'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'

export function useCtaButton({
  hasEmbroidery,
  hasSize,
  invalid,
  onAddToCart,
  onSelectEmbroidery,
  onViewProduct,
  soldOut,
  waitlistable,
}: {
  hasEmbroidery: boolean
  hasSize: boolean
  invalid: boolean
  onAddToCart(): void
  onSelectEmbroidery(): void
  onViewProduct(): void
  soldOut: boolean
  waitlistable: boolean
}) {
  const {
    selectAndAddVariant: {
      addToBagButton: { cta, selectEmbroidery, selectOptions, viewProduct, soldOutCta },
    },
  } = useTranslation()

  const disabled = invalid && !hasSize

  return useMemo(() => {
    if (!soldOut && hasEmbroidery) {
      return {
        disabled,
        onClick: onSelectEmbroidery,
        text: selectEmbroidery,
        variant: 'filled' as const,
      }
    }

    if (disabled) {
      return {
        disabled,
        onClick: () => {},
        text: selectOptions,
        variant: 'filled-neutral' as const,
      }
    }

    if (!soldOut) {
      return {
        disabled,
        onClick: onAddToCart,
        text: cta,
        variant: 'filled' as const,
      }
    }

    if (!waitlistable) {
      return {
        disabled: true,
        onClick: () => {},
        text: soldOutCta,
        variant: 'filled' as const,
      }
    }

    return {
      disabled,
      onClick: onViewProduct,
      text: viewProduct,
      variant: 'ghost' as const,
    }
  }, [
    disabled,
    hasEmbroidery,
    onAddToCart,
    onSelectEmbroidery,
    onViewProduct,
    selectEmbroidery,
    cta,
    soldOut,
    soldOutCta,
    viewProduct,
    waitlistable,
    selectOptions,
  ])
}
